module.exports = __webpack_public_path__ + "img/home-banner.f59a0d07.png";